import { createContext } from "react";

const AddSliderContext = createContext();

export default AddSliderContext;
